export default __webpack_public_path__ + "static/media/tenant-homebook.39863eaa.png";